import { Box, Stack, type SxProps, type Theme } from '@mui/material';
import { useSelector } from 'react-redux';
import useUnitProvider from '/@/core/context/unit';
import settings from '/@/core/settings';
import { useFieldById } from '/@/hooks/fields';
import { getSessionLanguage } from '/@/store/session/selectors';
import Spinner from '../spinner';

const NewWeather = ({
    fieldId,
    sx,
    minHeight = '532px',
}: {
    sx?: SxProps<Theme>;
    fieldId?: number;
    minHeight?: string;
}) => {
    const fieldsQuery = useFieldById({ id: fieldId });
    const language = useSelector(getSessionLanguage);

    const lat = fieldsQuery.data?.lat;
    const lng = fieldsQuery.data?.lng;
    const units = useUnitProvider();

    if (fieldsQuery.isValidating)
        return (
            <Stack justifyContent='center' alignItems='center' my={2}>
                <Spinner />
            </Stack>
        );

    if (!lat || !lng) return null;

    const appThemes: Record<string, 'yellow' | 'blue' | 'green' | 'default'> = {
        expertobayer: 'default',
        cultivio: 'green',
        agroeste: 'blue',
        agroceres: 'green',
        dekalb: 'yellow',
        latijereta: 'blue',
    };

    const iframeSrc = `https://weather.md.magoya.com/weather/forecast?lat=${lat}&lng=${lng}&language=${language}&theme=${
        appThemes[settings.app.theme]
    }&system=${units.system}`;

    return (
        <Box
            data-testid='weather-box'
            sx={[
                {
                    width: '100%',
                    height: '100%',
                    ...sx,
                },
            ]}
        >
            <iframe
                src={iframeSrc}
                id='weather-forecast-widget'
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    minHeight,
                }}
                title='Weather Forecast'
            />
        </Box>
    );
};

export default NewWeather;
